module.exports = __webpack_public_path__ + "img/Self-Serve.2f6d5248.svg";